import { Tabs } from 'antd';

import ContentManagementPage from '../../ContentManagement/ContentManagementPage';

const { TabPane } = Tabs;

const ServiceContentManagementPage = () => (
  <Tabs defaultActiveKey="serviceOnly" type="card" destroyInactiveTabPane>
    <TabPane tab="Service only" key="serviceOnly">
      <ContentManagementPage mode="serviceNoParams" />
    </TabPane>
    <TabPane tab="Service with parameter" key="serviceWithParams">
      <ContentManagementPage mode="serviceWithParams" />
    </TabPane>
  </Tabs>
);

export default ServiceContentManagementPage;
